export var LedgerDerivationPathType;
(function (LedgerDerivationPathType) {
    LedgerDerivationPathType["LedgerLive"] = "ledger-live";
    LedgerDerivationPathType["LedgerMew"] = "ledger-mew";
})(LedgerDerivationPathType || (LedgerDerivationPathType = {}));
export var WalletLedger;
(function (WalletLedger) {
    WalletLedger["Ledger"] = "ledger";
    WalletLedger["LedgerCosmos"] = "ledger-cosmos";
    WalletLedger["LedgerLegacy"] = "ledger-legacy";
})(WalletLedger || (WalletLedger = {}));
//# sourceMappingURL=types.js.map